import { I18nLocalesEnum } from '@zaoblako/shared/common/enums/i18n.locales.enum';
import { IronLogicCommandStatusEnum } from '@zaoblako/shared/modules/pacs/enums/iron-logic-command-status.enum';
import type { EnumI18nInterface } from '@zaoblako/shared/common/interfaces/enum.i18n.interface';

/** Localized human-readable string representations of {@link IronLogicCommandStatusEnum} enumeration values */
export const IronLogicCommandStatusEnumI18n: EnumI18nInterface<IronLogicCommandStatusEnum> = {
  [I18nLocalesEnum.RU_RU]: {
    [IronLogicCommandStatusEnum.SCHEDULED]: 'Запланирована',
    [IronLogicCommandStatusEnum.IN_PROGRESS]: 'Выполняется',
    [IronLogicCommandStatusEnum.SUCCEED]: 'Завершена успешно',
    [IronLogicCommandStatusEnum.FAILED]: 'Провалена',
    [IronLogicCommandStatusEnum.EXPIRED]: 'Просрочена',
  },
  [I18nLocalesEnum.EN_US]: {
    [IronLogicCommandStatusEnum.SCHEDULED]: 'Scheduled',
    [IronLogicCommandStatusEnum.IN_PROGRESS]: 'In progress',
    [IronLogicCommandStatusEnum.SUCCEED]: 'Succeed',
    [IronLogicCommandStatusEnum.FAILED]: 'Failed',
    [IronLogicCommandStatusEnum.EXPIRED]: 'Expired',
  },
};
